export const styles = () => ({
  content: { paddingTop: '0 !important' },
  row: { display: 'flex' },
  street: { width: 370 },
});
